<template>
  <div class="download-report-page">
    <div class="report-page">
      <div class="pdfpage">
        <ReportHeader :partnerlogo="imgurl" :brandname="brandname" :month="month" :report="reportname" />
        <div class="metrics-pdf-title">
          <h2>{{ reporttype == 1 ? $t('kpi.s02') : $t('kpi.s2') }}</h2>
        </div>
        <div class="metrics-pdf-body">
          <div class="kpis-page-top">
            <el-row :gutter="10">
              <el-col :span="12">
                <div class="kpis-page-col-panel">
                  <h3>{{ reporttype == 1 ? $t('kpi.s301') : $t('kpi.s3') }}</h3>
                  <h2 v-html="totalsku.currenthtml"></h2>
                  <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ totalsku.last }}</h4>
                  <span class="kpis-page-col-panel-bgicon kpcpb2"><i class="el-icon-present"></i></span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="kpis-page-col-panel">
                  <h3>{{ reporttype == 1 ? $t('kpi.s501') : $t('kpi.s5') }}</h3>
                  <h2 v-html="totalseller.currenthtml"></h2>
                  <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ totalseller.last }}</h4>
                  <span class="kpis-page-col-panel-bgicon kpcpb3"><i class="el-icon-shopping-cart-1"></i></span>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="kpis-page-second">
            <el-row :gutter="10">
              <el-col :span="12"><!--1-->
                <div class="kpis-page-col-box">
                  <el-row>
                    <el-col :span="12">
                      <div class="kpis-page-col-box-row1">
                        <h3>{{ reporttype == 1 ? $t('kpi.s601') : $t('kpi.s6') }}</h3>
                        <h2 v-html="lowpricesku.currenthtml"></h2>
                        <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ lowpricesku.last }}</h4>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="kpis-page-col-box-row2">
                        <el-row :gutter="10">
                          <el-col :span="24">
                            <div class="kpis-page-col-box-row2-c kpcbrc1">
                              <h4>{{ $t('kpi.s7') }}</h4>
                              <h5 v-html="lowpricesku.percentagehtml"></h5>
                              <MiniLineChart :chartdata="lowpricesku.trend" minilineid="minilineid2" />
                            </div>
                          </el-col>
                        </el-row>  
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="12"><!--2-->
                <div class="kpis-page-col-box">
                  <el-row>
                    <el-col :span="12">
                      <div class="kpis-page-col-box-row1">
                        <h3>{{ reporttype == 1 ? $t('kpi.s801') : $t('kpi.s8') }}</h3>
                        <h2 v-html="lowpriceseller.currenthtml"></h2>
                        <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ lowpriceseller.last }}</h4>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="kpis-page-col-box-row2">
                        <el-row :gutter="10">
                          <el-col :span="24">
                            <div class="kpis-page-col-box-row2-c kpcbrc2">
                              <h4>{{ $t('kpi.s9') }}</h4>
                              <h5 v-html="lowpriceseller.percentagehtml"></h5>
                              <MiniLineChart :chartdata="lowpriceseller.trend" minilineid="minilineid4" />
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="12" v-if="level/1 === 3 ? true : false"><!--3-->
                <div class="kpis-page-col-box">
                  <el-row>
                    <el-col :span="12">
                      <div class="kpis-page-col-box-row1">
                        <h3>{{ reporttype == 1 ? $t('kpi.s1001') : $t('kpi.s10') }}</h3>
                        <h2 v-html="infringementsku.currenthtml"></h2>
                        <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ infringementsku.last }}</h4>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="kpis-page-col-box-row2">
                        <el-row :gutter="10">
                          <el-col :span="24">
                            <div class="kpis-page-col-box-row2-c kpcbrc3">
                              <h4>{{ $t('kpi.s11') }}</h4>
                              <h5 v-html="infringementsku.percentagehtml"></h5>
                              <MiniLineChart :chartdata="infringementsku.trend" minilineid="minilineid6" />
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
              <el-col :span="12" v-if="level/1 === 3 ? true : false"><!--4-->
                <div class="kpis-page-col-box">
                  <el-row>
                    <el-col :span="12">
                      <div class="kpis-page-col-box-row1">
                        <h3>{{ reporttype == 1 ? $t('kpi.s1201') : $t('kpi.s12') }}</h3>
                        <h2 v-html="infringementseller.currenthtml"></h2>
                        <h4>{{ reporttype == 1 ? $t('kpi.s401') : $t('kpi.s4') }}：{{ infringementseller.last }}</h4>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="kpis-page-col-box-row2">
                        <el-row :gutter="10">
                          <el-col :span="24">
                            <div class="kpis-page-col-box-row2-c kpcbrc4">
                              <h4>{{ $t('kpi.s13') }}</h4>
                              <h5 v-html="infringementseller.percentagehtml"></h5>
                              <MiniLineChart :chartdata="infringementseller.trend" minilineid="minilineid8" />
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </div>
        </div><!--周期统计-->
        <div class="metrics-pdf-dashboard">
          <div class="metrics-pdf-title">
            <h2>{{ $t('report.s5') }}</h2>
          </div>
          <div class="report-charts-row">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="dashboard-container">
                  <LineChartPdf 
                    :charttitle="$t('report.s10')" 
                    :chartdata="linechartdata"
                    :animation="true"
                    chartid="line1"
                  />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="dashboard-container">
                  <LineChartPdf 
                    :charttitle="$t('report.s27')" 
                    :chartdata="linechartdata1"
                    :animation="true"
                    chartid="line2"
                  />
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="report-charts-row">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="dashboard-container">
                  <BarChartStackPdf
                    :charttitle="$t('report.s11')"
                    :chartdata="barchartstackdata"
                    chartid="barchartstack1"
                  />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="dashboard-container">
                  <BarChartStackPdf
                    :charttitle="$t('report.s28')"
                    :chartdata="barchartstackdata1"
                    chartid="barchartstack2"
                  />
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="report-charts-row">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="dashboard-container">
                  <LineMultChartPdf
                    charttitle="周期销量"
                    :chartdata="linemultchartdata0"
                    chartid="barchartstack3"
                    :animation="true"
                  />
                </div>
              </el-col>
              <el-col :span="12">
                <div class="dashboard-container">
                  <LineMultChartPdf
                    charttitle="周期推算销售额"
                    :chartdata="linemultchartdata1"
                    chartid="barchartstack4"
                    :animation="true"
                  />
                </div>
              </el-col>
            </el-row>
          </div>
        </div><!--图表-->
        <ReportFooter :update="update" :year="year" :page="1" :total="totalpdf" :height="footerheight" />
      </div><!-- 第一页 -->

      <div class="pdfpage" v-if="showp2">
        <ReportHeader :partnerlogo="imgurl" :brandname="brandname" :month="month" :report="reportname" />
          <div class="metrics-pdf-title">
            <h2>{{ $t('kpi.s104') }}</h2>
          </div>
          <div class="report-table-box">
            <div class="tablebox">
              <el-table :data="top10data1" size="mini">
                <el-table-column type='index' label=" " width="40"></el-table-column>
                <el-table-column prop='ShopId' label="SHOPID"></el-table-column>
                <el-table-column :label="$t('report.s33')">
                  <template slot-scope="scope">
                    <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                  </template>              
                </el-table-column>
                <el-table-column prop='SellerName' :label="$t('report.s55')"></el-table-column>
                <el-table-column :label="$t('report.s34')" width="80">
                  <template slot-scope="scope">
                    <i class="channelicon" :class="scope.row.Channel"></i>
                  </template>
                </el-table-column>
                <el-table-column width="70">
                  <template slot="header">
                    {{ $t('aistring.s11') }}
                  </template>
                  <template slot-scope="scope">{{ scope.row.SkuTotalTrade }}</template>              
                </el-table-column>
                <el-table-column  width="90">
                  <template slot="header">
                    {{ $t('jgjk.s244') }}
                  </template>
                  <template slot-scope="scope">{{ scope.row.SkuTotalAmountStr }}</template>  
                </el-table-column>
                <el-table-column prop='Discount' :label="$t('report.s60')" width="90"></el-table-column>
                <el-table-column prop='OFF' :label="$t('report.s61')" width="70"></el-table-column>
              </el-table>
            </div>
          </div>
        <ReportFooter :update="update" :year="year" :page="showp2 == true ? 2 : ''" :total="totalpdf" :height="footerheight" />
      </div><!-- 第二页 -->

      <div class="pdfpage" v-if="showp3">
        <ReportHeader :partnerlogo="imgurl" :brandname="brandname" :month="month" :report="reportname" />
          <div class="metrics-pdf-title">
            <h2>{{ $t('kpi.s105') }}</h2>
          </div>
          <div class="report-table-box">
            <div class="tablebox">
              <el-table :data="top10data2" size="mini">
                <el-table-column type='index' label=" " width="40"></el-table-column>
                <el-table-column prop='ShopId' label="SHOPID"></el-table-column>
                <el-table-column :label="$t('report.s33')">
                  <template slot-scope="scope">
                    <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                  </template>              
                </el-table-column>
                <el-table-column prop='SellerName' :label="$t('report.s55')"></el-table-column>
                <el-table-column :label="$t('report.s34')" width="80">
                  <template slot-scope="scope">
                    <i class="channelicon" :class="scope.row.Channel"></i>
                  </template>
                </el-table-column>
                <el-table-column width="90">
                  <template slot="header">
                    {{ $t('jgjk.s244') }}
                  </template>
                  <template slot-scope="scope">{{ scope.row.SkuTotalAmountStr }}</template>  
                </el-table-column>
                <el-table-column width="70">
                  <template slot="header">
                    {{ $t('aistring.s11') }}
                  </template>
                  <template slot-scope="scope">{{ scope.row.SkuTotalTrade }}</template>              
                </el-table-column>
                <el-table-column prop='Discount' :label="$t('report.s60')" width="90"></el-table-column>
                <el-table-column prop='OFF' :label="$t('report.s61')" width="70"></el-table-column>
              </el-table>
            </div>
          </div>          
        <ReportFooter :update="update" :year="year" :page="showp2 == true ? 3 : 2" :total="totalpdf" :height="footerheight" />
      </div><!-- 第三页 -->

      <div class="pdfpage">
        <ReportHeader :partnerlogo="imgurl" :brandname="brandname" :month="month" :report="reportname" />
          <div class="metrics-pdf-title">
            <h2>{{ $t('kpi.s103') }}</h2>
          </div>
          <div class="report-table-box">
            <div class="tablebox">
              <el-table :data="top10data3" size="mini">
                <el-table-column type='index' label=" " width="40"></el-table-column>
                <el-table-column prop='ShopId' label="SHOPID"></el-table-column>
                <el-table-column :label="$t('report.s33')">
                  <template slot-scope="scope">
                    <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                  </template>              
                </el-table-column>
                <el-table-column prop='SellerName' :label="$t('report.s55')"></el-table-column>
                <el-table-column :label="$t('report.s34')" width="80">
                  <template slot-scope="scope">
                    <i class="channelicon" :class="scope.row.Channel"></i>
                  </template>
                </el-table-column>
                <el-table-column  width="90">
                  <template slot="header">
                    {{ $t('jgjk.s244') }}
                  </template>
                  <template slot-scope="scope">{{ scope.row.SkuTotalAmountStr }}</template>  
                </el-table-column>
                <el-table-column prop='Discount' :label="$t('report.s60')" width="90"></el-table-column>
                <el-table-column prop='OFF' :label="$t('report.s61')" width="70"></el-table-column>
              </el-table>
            </div>
          </div>
        <ReportFooter :update="update" :year="year" :page="showp2 == true && showp3 == true ? 4 : 3" :total="totalpdf" :height="footerheight" />
      </div><!-- 第四页 -->

    </div><!--report-page-->
  </div>
</template>

<script>
import ReportHeader from '@/components/Commons/Header.vue'
import ReportFooter from '@/components/Commons/Footer.vue'
import MiniLineChart from '@/components/Charts/MiniLineChart.vue'
import LineChartPdf from '@/components/Charts/LineChartPdf.vue'
import BarChartStackPdf from '@/components/Charts/BarChartStackPdf.vue'
import LineMultChartPdf from '@/components/Charts/LineMultChartPdf.vue'
export default {
  components:{
    ReportHeader,
    ReportFooter,
    MiniLineChart,
    LineChartPdf,
    BarChartStackPdf,
    LineMultChartPdf
  },
  data(){
    return{
      totalpdf: 4,
      subid: this.$route.params.SubId,
      month: this.$route.params.Month,
      type: this.$route.params.Type,
      reporttype: this.$route.params.Type,
      level: this.$route.params.Level,
      update: '',
      reportname: '',
      lan: this.$route.params.Lan,
      brandname: '',
      year: '',
      footerheight: this.$route.params.Lan === 'zh' ? 180 : 240,
      imgurl: '',

      totalsku: {},
      totalseller: {},
      lowpricesku: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      lowpriceseller: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      infringementsku: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      infringementseller: {
        trend: {
          xdata: [],
          ydata: []
        }
      },
      linechartdata: {},
      linechartdata1: {},
      barchartstackdata: {},
      barchartstackdata1: {},
      linemultchartdata0: {},
      linemultchartdata1: {},
      top10data1: [],
      top10data2: [],
      top10data3: [],
      showp2: true,
      showp3: true
    }
  },

  mounted(){
    this.$i18n.locale = this.lan
    this.reportname = this.$route.params.Type == 1 ? this.$t('pdftxt.MetricsMonthlyReport') : this.$t('pdftxt.MetricsWeeklyReport')
    this.getPartnerLogo()
    this.getPdf()
  },

  methods: {
    
    /**
     * 获取PDF数据
     */
    getPdf: function(){
      let that = this
      let _last = ''
      let _timerange = ''
      if(that.type == 1){
        _last = that.$moment(that.month).subtract(1,'month').format('YYYY-MM')
        _timerange = '\'' + _last + '\',\'' + that.month + '\''
      }
      if(that.type == 2){
        let _y = that.month.slice(0,4)
        let _yweek = _y + '00'
        let _lastyear = that.$moment(_y).subtract(1,'year').endOf("year").format('YYYY-MM-DD')
        let _w = that.$moment(_lastyear).isoWeek()
        let _lastweek = that.month - 1 > _yweek*1 ? that.month-1 : that.$moment(_lastyear).format('YYYY') + '' + _w
        _timerange = '\'' + _lastweek + '\',\'' + that.month + '\''
      }
      let url = that.API_URL + '/v3/price/statistics/pdfReport?'
          + 'project=' + that.subid
          + '&type=' + that.type
          + '&time=' + that.month
          + '&timeRange=' + _timerange
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
				crossDomain: true,
        success: function(data){
          console.log(data)
          that.brandname = data.results.projectInfo.name

          let _dashboard = data.results.dashboard

          let infringementlist = _dashboard[6][0]
          let lowpricelist = _dashboard[7][0]

          // 本期侵权率
          let currentinfringementsku = infringementlist.length > 0 ? infringementlist[0].skurate : 0
          let currentinfringementsku_p = infringementlist.length > 1 ? currentinfringementsku - infringementlist[1].skurate : 0
          // 本期侵权卖家占比
          let currentinfringementseller = infringementlist.length > 0 ? infringementlist[0].shoprate : 0
          let currentinfringementseller_p = infringementlist.length > 1 ? currentinfringementseller - infringementlist[1].shoprate : 0
          // 本期低价率
          let currentlowpricesku = lowpricelist.length > 0 ? lowpricelist[0].skurate : 0
          let currentlowpricesku_p = lowpricelist.length > 1 ? currentlowpricesku - lowpricelist[1].skurate : 0
          // 本期低价卖家占比
          let currentlowpriceseller = lowpricelist.length > 0 ? lowpricelist[0].shoprate : 0
          let currentlowpriceseller_p = lowpricelist.length > 1 ? currentlowpriceseller - lowpricelist[1].shoprate : 0

          // 最近更新时间
          that.update = that.$moment(_dashboard[8][0].scoreTime).utc().format('YYYY-MM-DD')

          // 累计SKU
          that.totalsku = {
            last: that.millonFormat(_dashboard[0][0].lastskuweekCount),
            currenthtml: that.setCompare(that.millonFormat(_dashboard[0][0].skuweekCount), _dashboard[0][0].skuweekRate)
          }
          // 累计卖家
          that.totalseller = {
            last: that.millonFormat(_dashboard[1][0].lastshopweekCount),
            currenthtml: that.setCompare(that.millonFormat(_dashboard[1][0].shopweekCount), _dashboard[1][0].shopweekRate)
          }
          // 低价SKU
          that.lowpricesku = {
            last: that.millonFormat(_dashboard[2][0].lastskuweeklowCount),
            currenthtml: that.setCompare(that.millonFormat(_dashboard[2][0].skuweeklowCount), _dashboard[2][0].skuweeklowRate),
            percentagehtml: that.setPercentage(currentlowpricesku, currentlowpricesku_p),
            trend: {
              xdata: lowpricelist.reverse().map(item => {
                return item.weeks
              }),
              ydata: lowpricelist.reverse().map(item => {
                return item.skurate * 100
              })
            }
          }
          // 低价卖家
          that.lowpriceseller = {
            last: that.millonFormat(_dashboard[3][0].lastshopweeklowCount),
            currenthtml: that.setCompare(that.millonFormat(_dashboard[3][0].shopweeklowCount), _dashboard[3][0].shopweeklowRate),
            percentagehtml: that.setPercentage(currentlowpriceseller, currentlowpriceseller_p),
            trend: {
              xdata: infringementlist.reverse().map(item => {
                return item.weeks
              }),
              ydata: infringementlist.reverse().map(item => {
                return item.shoprate * 100
              })
            }
          }
          // 侵权SKU
          that.infringementsku = {
            last: that.millonFormat(_dashboard[4][0].lastskuweekqinCount),
            currenthtml: that.setCompare(that.millonFormat(_dashboard[4][0].skuweekqinCount), _dashboard[4][0].skuweekqinRate),
            percentagehtml: that.setPercentage(currentinfringementsku, currentinfringementsku_p),
            trend: {
              xdata: infringementlist.reverse().map(item => {
                return item.weeks
              }),
              ydata: infringementlist.reverse().map(item => {
                return item.skurate * 100
              })
            }
          }
          // 侵权卖家
          that.infringementseller = {
            last: that.millonFormat(_dashboard[5][0].lastshopweekqinCount),
            currenthtml: that.setCompare(that.millonFormat(_dashboard[5][0].shopweekqinCount), _dashboard[5][0].shopweekqinRate),
            percentagehtml: that.setPercentage(currentinfringementseller, currentinfringementseller_p),
            trend: {
              xdata: lowpricelist.reverse().map(item => {
                return item.weeks
              }),
              ydata: lowpricelist.reverse().map(item => {
                return item.shoprate * 100
              })
            }
          }

          // 数据看板
          let lineChartDataObj = data.results.itemchart[0]
          let x = [];
          let y = [];
          for (var i = 0; i < lineChartDataObj.length; i++) {
              x[i] = that.$moment(lineChartDataObj[i].CurrentDate).format('YYYY-MM-DD')
              y[i] = lineChartDataObj[i].ItemCount
          }
          that.linechartdata = {
            xAxis: x,
            yAxis: [{
              type: 'line',
              smooth: true,
              data: y
            }]
          }
          
          let lineChartDataObj1 = data.results.shopchart[0]
          let x1 = [];
          let y1 = [];
          for (var j = 0; j < lineChartDataObj1.length; j++) {
              x1[j] = that.$moment(lineChartDataObj1[j].CurrentDate).format('YYYY-MM-DD')
              y1[j] = lineChartDataObj1[j].ShopCount
          }
          that.linechartdata1 = {
            xAxis: x1,
            yAxis: [{
              type: 'line',
              smooth: true,
              data: y1
            }]
          }

          let barresults = data.results.itemchart[1]
          barresults.forEach(item => {
            item.ChannelStr = that.setChannel(item.Channel).loc
          })
          that.barchartstackdata = {
            legenddata0: barresults.length > 0 ? that.$t("Infringements.t15") : '',
            legenddata1: barresults.length > 0 ? that.$t("Infringements.t11") : '',
            channelname: barresults.map(item => {return item.ChannelStr}),
            data0: barresults.map(item => {return item.OtherItem}),
            data1: barresults.map(item => {return item.FakeItem})
          }
          
          let barresults1 = data.results.shopchart[1]
          barresults1.forEach(item => {
            item.ChannelStr = that.setChannel(item.Channel).loc
          })
          that.barchartstackdata1 = {
            legenddata0: barresults1.length > 0 ? that.$t("Seller.t6") : '',
            legenddata1: barresults1.length > 0 ? that.$t("Seller.t5") : '',
            channelname: barresults1.map(item => {return item.ChannelStr}),
            data0: barresults1.map(item => {return item.OtherShop}),
            data1: barresults1.map(item => {return item.FakeShop})
          }


          let _s0 = data.results.dashboard[9].sales
          let _s1 = data.results.dashboard[9].salesvolume
          let _sd0 = []
          let _sd1 = []
          for(let i=0; i<_s0.length; i++){
            let _a = {
              color: that.setChannel(_s0[i].name).color,
              name: _s0[i].name,
              data: _s0[i].data.map(item => {
                return item <= 0 ? 0.00 : item
              }),
              type: 'line'
            }
            _sd0.push(_a)
          }
          for(let j=0; j<_s1.length; j++){
            let _b = {
              color: that.setChannel(_s1[j].name).color,
              name: _s1[j].name,
              data: _s1[j].data.map(item => {
                return item <= 0 ? 0.00 : item
              }),
              type: 'line'
            }
            _sd1.push(_b)
          }
          that.linemultchartdata0 = {
            xAxis_data: data.results.dashboard[9].xdatetime,
            series_data: _sd0
          }
          that.linemultchartdata1 = {
            xAxis_data: data.results.dashboard[9].xdatetime,
            series_data: _sd1
          }          

          that.top10data1 = that.setReportTable(data.results.TBShopList)
          that.top10data2 = that.setReportTable(data.results.otherShopList)
          that.top10data3 = that.setReportTable(data.results.discountShopList)

          if(data.results.TBShopList.length==0){
            that.showp2 = false
            that.totalpdf = 3
          }
          if(data.results.otherShopList.length==0){
            that.showp3 = false
            that.totalpdf = 3
          }

        },
        error: function(err){
          console.log(err)
        }
      })

    },
    
    /**
     * 获取合作伙伴Logo
     */
    getPartnerLogo: function(){
      let that = this
      let url = that.API_URL + '/partnerlogo/partnerlogo.json'
      $.ajax({
        url:  url,
        type: "GET",
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          let plogo = rex.partnerlogo
          for(let i=0; i<plogo.length; i++){
            for(let j=0; j<plogo[i].subid.length; j++){
              if(plogo[i].subid[j] == that.subid){
                that.imgurl = that.API_URL + plogo[i].reportlogo
              }
            }
          }
        },
        error: function(response) {
          console.log('getPartnerLogo', response)
        }
      })
    },

  }
}
</script>